"use client";

import { forwardRef } from "react";
import { cn } from "~/lib/utils";

export interface CheckboxProps
	extends Omit<React.HTMLAttributes<HTMLButtonElement>, "onChange"> {
	checked?: boolean;
	onChange?: (checked: boolean) => void;
	label: string;
	disabled?: boolean;
}

const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(
	({ className, checked = false, onChange, label, disabled = false, ...props }, ref) => {
		const handleClick = () => {
			if (!disabled && onChange) {
				onChange(!checked);
			}
		};

		return (
			<button
				ref={ref}
				type="button"
				disabled={disabled}
				className={cn(
					"flex items-center gap-2 text-left",
					!disabled && "cursor-pointer",
					disabled && "cursor-not-allowed opacity-50",
					className,
				)}
				onClick={handleClick}
				{...props}
			>
				<div
					className={cn(
						"flex h-4 w-4 items-center justify-center rounded-[3px] border transition-colors",
						checked
							? "border-[#1c3144] bg-[#1c3144]"
							: "border-[rgba(0,6,46,0.2)] bg-[rgba(255,255,255,0.9)]",
					)}
				>
					{checked && (
						<svg
							className="h-2.5 w-2.5 text-white"
							viewBox="0 0 10 8"
							fill="none"
						>
							<path
								d="M1 4L3.5 6.5L9 1"
								stroke="currentColor"
								strokeWidth="1.5"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					)}
				</div>
				<p className="text-sm font-normal leading-5 text-[#1c2024]">{label}</p>
			</button>
		);
	},
);

Checkbox.displayName = "Checkbox";

export { Checkbox };

